<template>
  <div class="orderInquery">
    <h2>订单查询</h2>
    <el-form size="medium" :inline="true" :model="OrderForm" class="demo-form-inline">
      <el-form-item label="客户编号:">
        <el-input v-model="OrderForm.userName" placeholder="客户编号" />
      </el-form-item>
      <el-form-item label="订单编号:">
        <el-input v-model="OrderForm.orderNo" placeholder="订单编号" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit">
          查询
        </el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button v-if="isShow" type="primary" icon="el-icon-printer" @click="printContent">
          打印
        </el-button>
      </el-form-item> -->
      <el-form-item>
        <el-button v-if="isShow" type="primary" icon="el-icon-download" class="btn btn-primary" @click="printOut">
          导出PDF
        </el-button>
      </el-form-item>
    </el-form>
    <div
      v-if="isShow"
      id="pdfDom"
      v-loading="loading"
      class="ordercontent"
      style="font-size:18px;"
    >
      <el-row>
        <div v-if="Isoperation" v-html="data.html_head" />
      </el-row>
      <el-row v-if="data.usercompany==='0021' && IsPrint" style="text-align:center;">
        <h1>上海申力生物科技有限公司</h1>
        <h1>冷链配送过程温度清单</h1>
      </el-row>
      <el-row v-if="data.usercompany==='0038' && IsPrint" style="text-align:center;">
        <h1>上海力胜生物科技有限公司</h1>
        <h1>配送过程温度清单</h1>
      </el-row>
      <el-row class="rowtext">
        <el-col :xs="24" :sm="12">
          <h3>订单信息:</h3>
          <p>发货单号:{{ data.orderno }}</p>
          <p>开始时间:{{ data.expresstimeStart }}</p>
          <p>结束时间:{{ data.expresstimeEnd }}</p>
          <p>客户编号:{{ data.customerNo }}</p>
          <p>客户名称:{{ data.customerName }}</p>
          <p>客户地址:{{ data.cusomerAddress }}</p>
        </el-col>
        <el-col :xs="24" :sm="12">
          <h3>配送信息</h3>
          <p>设备信息:{{ data.devices }}</p>
          <p>最高温度:{{ data.maxTemperature }}</p>
          <p>最低温度:{{ data.minTemperature }}</p>
          <p>配送时长:{{ data.orderExpressDurtion }}</p>
          <p>配送公司:{{ data.postCompany }}</p>
          <p>配送人:{{ data.postManName }}</p>
        </el-col>
      </el-row>
      <el-row>
        <el-card v-for="itme in data.deviceinfoesList" :key="itme.id">
          <div slot="header" class="clearfix">
            <h3>{{ itme.devicename }}过程温度记录</h3>
            <el-button icon="el-icon-tickets" style="float: right; padding: 3px 0" type="text" />
          </div>
          <div>
            <el-row>
              <el-col :xs="24" :sm="8" :md="8">
                <p v-for="(result) in itme.dataList1" :key="result.recTime">
                  {{ result.showText }}
                </p>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8">
                <p v-for="(result) in itme.dataList2" :key="result.recTime">
                  {{ result.showText }}
                </p>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8">
                <p v-for="(result) in itme.dataList3" :key="result.recTime">
                  {{ result.showText }}
                </p>
              </el-col>
            </el-row>
            <!-- <el-row class="listtext">
              <el-col v-for="(list) in itme.dataList" :key="list.recTime" :span="8">
                <span v-html="list.showText" />
              </el-col>
            </el-row> -->
          </div>
        </el-card>
      </el-row>
      <el-row class="Chart">
        <div v-show="Isoperation && !IsPrint" id="myChart" style="width:100%; height: 350px" />
      </el-row>
      <el-row class="gpsMap">
        <div v-if="gpsTrackingDatas.length>0">
          <mapGPS :gpslist="gpsTrackingDatas" />
        </div>
      </el-row>
      <el-row />
      <el-row v-show="IsPrint" id="ChartPint">
        图表转图片
      </el-row>
    </div>
  </div>
</template>

<script>
import html2Canvas from 'html2canvas'
import mapGPS from './mapGPS'
import JsPDF from 'jspdf'
import request from '../utils/request.js'
import { longStackSupport } from 'q'
export default {
  name: 'OrderInquery',
  components: {
    mapGPS
  },
  data() {
    return {
      htmlTitle: '',
      Isoperation: true,
      IsPrint: false,
      loading: true,
      isShow: false,
      gpsTrackingDatas: [],
      OrderForm: {
        userName: '',
        orderNo: ''
      },
      data: {},
      option: {
        title: {
          text: '配送过程温度曲线图'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        toolbox: {
          show: false,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value} °C'
            }
          }
        ],
        series: [
          {
            name: '',
            type: 'line',
            data: [],
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' }
              ]
            },
            markLine: {
              data: [
                { type: 'average', name: '平均值' }
              ]
            }
          },
          {
            name: '最低气温',
            type: 'line',
            data: [],
            markLine: {
              data: [
                { type: 'average', name: '平均值' }
              ]
            }
          }
        ]
      },
      myChart: {}
    }
  },
  mounted() {
    this.GetUrlParam()
  },
  methods: {
    onSubmit() {
      this.Isoperation = true
      this.myChart = {}
      if (this.OrderForm.orderNo === '' || this.OrderForm.userName === '') {
        this.$message({
          message: '查询条件不能为空！',
          type: 'warning'
        })
        return true
      }
      this.loading = true
      this.isShow = true
      request({
        url: '/expressorderinfoes/getOrderDetailInfo',
        method: 'post',
        data: `orderNo=${this.OrderForm.orderNo}&userName=${this.OrderForm.userName}`
      }).then(Response => {
        console.log(Response)
        this.htmlTitle = Response.data.data.orderno
        this.data = Response.data.data
        // 遍历gps数据
        if (this.data.gpsTrackingDatas.length > 0) {
          this.gpsTrackingDatas = []
          this.data.gpsTrackingDatas.forEach(itme => {
            var gps = JSON.parse(itme.lbs)
            this.gpsTrackingDatas.push([+gps.longitude, +gps.latitude])
          })
        }
        console.log(this.gpsTrackingDatas)
        this.data.deviceinfoesList.forEach((element, index) => {
          this.option.legend.data.push(element.devicename)
          this.option.series[index].name = element.devicename
          this.option.yAxis[index].min = element.low
          this.option.yAxis[index].max = element.top
          var rowLength = Math.floor(element.resultQueryReturnList.length / 3)
          if (element.resultQueryReturnList.length % 3 > 0) {
            rowLength++
          }
          element.rowLength = rowLength
          element.dataList = []
          element.dataList1 = []
          element.dataList2 = []
          element.dataList3 = []
          element.resultQueryReturnList.forEach((item, resultIndex) => {
            var resultInfo = {}
            resultInfo.index = resultIndex + 1
            resultInfo.body = item
            resultInfo.showText = `${resultInfo.index}:${item.recTime} ${item.temperature}`
            resultInfo.row = Math.floor(resultIndex / 3)
            resultInfo.col = resultIndex % 3
            element.dataList.push(resultInfo)
            var afterCalcIndex = resultInfo.col * element.rowLength + resultInfo.row
            resultInfo.afterCalcIndex = afterCalcIndex
            if (Math.floor(resultIndex / rowLength) === 0) {
              element.dataList1.push(resultInfo)
            }
            if (Math.floor(resultIndex / rowLength) === 1) {
              element.dataList2.push(resultInfo)
            }
            if (Math.floor(resultIndex / rowLength) === 2) {
              element.dataList3.push(resultInfo)
            }
          })
          element.dataList1.forEach((item, index2) => {
            this.option.xAxis[0].data.push(item.body.recTime)
            this.option.series[0].data.push(item.body.temperature)
          })
          element.dataList2.forEach((item, index2) => {
            this.option.xAxis[0].data.push(item.body.recTime)
            this.option.series[0].data.push(item.body.temperature)
          })
          element.dataList3.forEach((item, index2) => {
            this.option.xAxis[0].data.push(item.body.recTime)
            this.option.series[0].data.push(item.body.temperature)
          })
        })
        this.drawLine()
        this.loading = false
      }).catch(value => {
        console.log('返回失败')
        this.loading = false
      })
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      console.log(this.option)
      this.myChart.setOption(this.option)
    },
    // 打印
    printContent(e) {
      this.IsPrint = true
      setTimeout(() => {
        var picInfo = this.myChart.getDataURL()
        document.getElementById('ChartPint').innerHTML = `<img class='imgpint' src='${picInfo}'/>`
        setTimeout(() => {
          const subOutputRankPrint = document.getElementById('pdfDom')
          const newContent = subOutputRankPrint.innerHTML
          document.body.innerHTML = newContent
          window.print()
          // window.location.reload()
        }, 500)
      }, 500)
      // setTimeout(() => {
      //   const subOutputRankPrint = document.getElementById('pdfDom')
      //   const newContent = subOutputRankPrint.innerHTML
      //   document.body.innerHTML = newContent
      //   window.print()
      //   window.location.reload()
      //   return false
      // }, 1000)
    },
    printOut() {
      this.Isoperation = false
      this.IsPrint = true
      setTimeout(() => {
        var picInfo = this.myChart.getDataURL()
        document.getElementById('ChartPint').innerHTML = "<img class='imgpint' src='" + picInfo + "'/>"
        setTimeout(() => {
          this.topdf(this.htmlTitle)
          // this.getPdf(this.htmlTitle,0,true)
        }, 500)
      }, 500)
    },
    topdf(htmlTitle) {
      document.getElementById("pdfDom").scrollTop = 0;
      html2Canvas(document.getElementById("pdfDom"), {
        useCORS: true,
        dpi: 300,
      }).then(function (canvas) {
        var context = canvas.getContext('2d');
        //关闭抗锯齿
        context.mozImageSmoothingEnabled = false;
        context.webkitImageSmoothingEnabled = false;
        context.msImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false;
        //画布大小
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        // 将canvas转为base64图片
        var pageData = canvas.toDataURL('image/jpeg', 1.0);
        // 设置pdf的尺寸，pdf要使用pt单位 已知 1pt/1px = 0.75   pt = (px/scale)* 0.75
        var pdfWidth = (contentWidth + 10) * 0.75;
        var pdfHeight = (contentHeight + 500) * 0.75;
 
        // 设置内容图片的尺寸，img是pt单位
        var imgWidth = pdfWidth;
        var imgHeight = (contentHeight * 0.75);
 
        //初始化jspdf 第一个参数方向：默认''时为纵向，第二个参数设置pdf内容图片使用的长度单位为pt，第三个参数为PDF的大小，单位是pt
        // const PDF = new jsPDF('', 'pt', [pdfWidth, pdfHeight]);
        let PDF = new JsPDF({
            // landscape：横向打印，默认纵向打印
            orientation:'',
            unit: 'pt',
            format: [pdfWidth, pdfHeight],
          });
 
        PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        PDF.save(`${htmlTitle}.pdf`);
      })
    },
    getPdf(title, type, longitudinalShow = false) {
      return new Promise((res, rej) => {
        html2Canvas(document.querySelector('#pdfDom'), {
          allowTaint: true, // 是否允许不同源的图片污染画布
          taintTest: false, // 是否在渲染前测试图片
          useCORS: true, // 是否尝试使用 CORS 从服务器加载图片
          dpi: window.devicePixelRatio * 1, // 将分辨率提高到特定的DPI
          scale: 1, // 用于渲染的比例，默认为浏览器设备像素比率
        }).then((canvas) => {
          // a4纸 pt尺寸
          let a4Size = {
            w: 595.28,
            h: 841.89,
          };
          // 算的是 px单位需要转 pt，a4纸与当前canvas的间距，用于居中
          let l = (((longitudinalShow ? a4Size.h : a4Size.w) * 1.33 - canvas.width) / 2) * 0.75;

          let pageData = canvas.toDataURL('image/jpeg', 1.0);

          let PDF = new JsPDF({
            // landscape：横向打印，默认纵向打印
            orientation: longitudinalShow ? 'landscape' : '',
            unit: 'pt',
            format: 'a4',
          });
          // 表高度，pt单位比较
          let sheetHeight = canvas.height * 0.75;
          let t = 0;
          // 是否需要转换宽高(a4纸打印做转向了，但是分页处理没有转向)
          let isRotate = longitudinalShow ? a4Size.w : a4Size.h;
          // 当表小于a4的高时，无需分页
          if (isRotate > sheetHeight) {
            /*
          addImage(img, JPEG, left, top, width, height) pt单位
            1. 宽高传0，默认为原始图片的px单位
            2. 如果传入图片原始宽高会识别为pt，打印出来后会进行1.333倍的放大
            3. 打个比方a4纸的宽pt单位为595.28，px单位为793.71，一个图片宽高为180px
              如果使用默认为0的，打印出来还是为180px，如果手动设置180，打印出来就会转换为240px
              意思就是如果图片原始为px单位，设置的pt单位打印就不需要传，如果图片原始为pt单位，设置的pt单位打印就需要传
        */
            PDF.addImage(pageData, 'JPEG', l, 24, 0, 0);
          } else {
            while (sheetHeight > 0) {
              PDF.addImage(pageData, 'JPEG', l, t, 0, 0);
              sheetHeight -= isRotate;
              t -= isRotate;
              // 避免添加空白页
              if (sheetHeight > 0) {
                PDF.addPage();
              }
            }
          }
          PDF.save(title + '.pdf')
            setTimeout(() => {
              window.location.reload()
            }, 500)
          });
      });
    },
    GetUrlParam() {
      var url = document.location.toString()
      var arrObj = url.split('?')
      console.log(arrObj)
      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split('&')
        var arr
        console.log(arrPara)
        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split('=')
          console.log(arr)
          if (arr[0] === 'userName') {
            this.OrderForm.userName = arr[1]
          } else if (arr[0] === 'orderNo') {
            this.OrderForm.orderNo = arr[1]
          }
        }
        this.onSubmit()
      } else {
        console.log('没有携带参数')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.orderInquery{
  padding-left: 10%;
  padding-right: 10%;
}
#pdfDom{
  margin-left: 30px;
  text-align: center;
}
.imgpint{
  width: 100%;
}
.pintInquery{
  display: none;
  /* font-size: 12px; */
}
.rowtext{
  margin-top: 0px;
  margin-left: 20px;

}
.listtext{
   font-size: 16px;
}
.ordercontent{
  border-top:slategray solid 2px;
}

  .text {
    font-size: 14px;
    margin-bottom: 5px;
  }

  .box-card {
    width: 100%;
  }
</style>
